import { render, staticRenderFns } from "./ChapCard.vue?vue&type=template&id=9842eb30&scoped=true&"
import script from "./ChapCard.vue?vue&type=script&lang=js&"
export * from "./ChapCard.vue?vue&type=script&lang=js&"
import style0 from "./ChapCard.vue?vue&type=style&index=0&id=9842eb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9842eb30",
  null
  
)

export default component.exports